<template>
  <!-- <span style="color: red">{{ state.activeTab }}</span> -->
  <Tabs :list="state.list" v-model="state.activeTab" style="margin-top: 50px">
    <div v-for="(comp, index) in state.list" :key="index" class="tabContentBox">
      <Lidar360Detail
        v-if="
          state.activeTab === comp.name && state.activeTab.includes('Details')
        "
        :data="comp.children"
      />
      <Lidar360Technical
        v-if="
          state.activeTab === comp.name && state.activeTab.includes('Technical')
        "
        :data="comp.children"
      />
      <Lidar360System
        v-if="
          state.activeTab === comp.name && state.activeTab.includes('System')
        "
        :data="comp.children"
      />
    </div>
  </Tabs>
</template>

<script setup>
import Tabs from "../../Tabs";
import Lidar360Detail from "./lidar360/Detail.vue";
import Lidar360Technical from "./lidar360/Technical.vue";
import Lidar360System from "./lidar360/System.vue";

const tabData = inject("tabData");

const state = reactive({
  list: [
    // {
    //   name: "Details",
    //   children: [],
    // },
    // {
    //   name: "Technical Capabilities",
    //   children: [],
    // },
    // {
    //   name: "System Requirements",
    //   children: [],
    // },
  ],
  activeTab: "",

  tabDetail: [],
  tabTechnical: [],
  tabSystem: [], // '["Vector mapping with multi-source data fusion","3D mapping based on point clouds","3D mapping based on imagery (panoramic/planar/ortho)","Over 100 vector mapping, processing, editing tools","Multiple output formats, seamless integration with GIS, CAD and simulation platform"]',
});

onMounted(() => {
  if (tabData?.items && tabData?.items.length > 0) {
    state.list = tabData?.items.map((item) => {
      return {
        name: item.data.title,
        children: item.children,
      };
    });
    state.activeTab = tabData?.items[0]?.data?.title;
  }
});
</script>

<style lang="less" scoped>
.tabContentBox {
  width: 100%;
  max-width: 1374px; // 解决轮播异常导致页面宽度拉长问题
}
</style>
